// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1FTv6","info":"PatientInfo_info__1pLBU"};